import SnowflakeProperties from '../models/snowflakeProperties';
import useRestService from '../shared/rest-service';

const useSnowflakeProperties = () => {
  const { getAuth, putAuth } = useRestService();

  const fetchSnowflakeProperties = (clientId: string): Promise<SnowflakeProperties> => {
    return getAuth(`api/clients/${clientId}/snowflake-properties`).then((snowflakeProperties: SnowflakeProperties) => {
      return snowflakeProperties;
    });
  };

  const editSnowflakeProperties = (clientId: string, snowflakeProperties: SnowflakeProperties): Promise<any> => {
    return putAuth(`api/clients/${clientId}/snowflake-properties`, snowflakeProperties);
  };

  return {
    fetchSnowflakeProperties,
    editSnowflakeProperties
  };
};

export default useSnowflakeProperties;
